import { $ } from 'utils/dom';
import { gsap } from 'gsap';

const BREAKPOINT = Object.freeze({
  tablet: 767,
  desktop: 1199,
});

export const viewport = {
  isDesktop: false,
  isTablet: false,
  isMobile: false,
  isReduced: false,
};

const initViewport = () => {
  const mm = gsap.matchMedia();

  mm.add(
    {
      isDesktop: `(min-width: ${BREAKPOINT.desktop + 1}px)`,
      isTablet: `(min-width: ${BREAKPOINT.tablet + 1}px) and (max-width: ${
        BREAKPOINT.desktop
      }px)`,
      isMobile: `(max-width: ${BREAKPOINT.tablet}px)`,
      isReduced: '(prefers-reduced-motion: reduce)',
    },
    context => {
      Object.assign(viewport, context.conditions);
    }
  );
};

const story = $('.story');

if (story) {
  initViewport();
}
